import React from 'react';
import Dashboard from './Dashboard';

const Pathology: React.FC = () => {
  return <Dashboard />;
};

export default Pathology;
